<div class="container update-members main width-alignment">
    <!-- <div class="col-12 Individual createGroup">
        <div class="update-group">
        <label for="select" class="lable-size">Exchange Information - {{relname}}</label>
    </div> -->
    <div *ngIf="urlSafe" class="modal fade" id="viewWithmeModal" tabindex="-1" role="dialog"
        aria-labelledby="viewWithmeModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">View</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="watermark">
                        <div class="safeurl">
                            <iframe height="250px" width="auto" [src]="urlSafe"></iframe>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
    <!-- <div class="row">
        <div class="col-6">
            <div class="update-group"> 
                 <span (click)="back()"><i class="fa fa-angle-left goback" aria-hidden="true"></i>  </span>
                <label for="select" class="lable-sized">
                    <h1 class="exchange" *ngIf="reldata.clientType.toLowerCase() == 'entity'">Profile - {{profileInfo.fullname}}</h1>
                     <h1 class="exchange" *ngIf="reldata.clientType.toLowerCase() == 'consumer'">Profile - {{profileInfo.first_name}} {{profileInfo.last_name}}</h1>
                </label>
            </div>
        </div>
        <div class="col-6" *ngIf="currentTab!='documents'">
            <div class="switch relationship-tabs cswitch" *ngIf="reldata.isAccepted">
                <span class="relSubTab individuals" (click)="currentTab='profile';isConformation=false;">
                    <a href="javascript: void(0)" [ngClass]="{'active' : currentTab=='profile','single-tab': reldata?.pending == 'true'}"
                        class="optionone compone relation-sub-tabs">Profile</a>
                </span>
                <span class="relSubTab business" (click)="documentsClick();currentTab='documents';isConformation=false;">
                    <a href="javascript: void(0)" [ngClass]="{'active' : currentTab=='documents'}"
                        class="optiontwo relation-sub-tabs compotwoo comptwo">Documents</a>
                </span>
            </div>
        </div>
        <div class="col-6" *ngIf="currentTab=='documents'">
        </div>
    </div> -->
    <!-- <div class="row">
        <div style="height:50px;">
        </div>
    </div> -->
   <!--- <div class="row" *ngIf=" profileInfo && currentTab=='profile'">
        <div class="col-6" *ngIf="reldata.clientType.toLowerCase() == 'entity'">
            <h3 class="profile">Profile - {{profileInfo.fullname}}</h3>
        </div>
        <div class="col-6" *ngIf="reldata.clientType.toLowerCase() == 'consumer'">
            <h3 class="profile">Profile - {{profileInfo.first_name}} {{profileInfo.last_name}}</h3>
        </div>
        <div class="col-6" *ngIf="reldata.clientType == 'Consumer'">
            <h3 class="citizen">Citizenship</h3>
        </div>
    </div>


     <div class="row" *ngIf="currentTab=='profile' && profileInfo && isEntityProfile">
        <div class="col-4">
            <div class="form-group nameSet">
                <label for="name" class="lable-size">Name </label>
                <input type="text" [(ngModel)]="profileInfo.fullname" class="text-size form-control group-name-text"
                    disabled name="name">
            </div>
            <div class="form-group nameSet">
                <label for="email" class="lable-size">Email</label>
                <input type="text" [(ngModel)]="profileInfo.email" class="text-size form-control group-name-text"
                    disabled name="email">
            </div>
            <div class="form-group nameSet">
                <label for="phonenumber" class="lable-size">Phone Number</label>
                <input type="text" [(ngModel)]="profileInfo.contact_phone"
                    class="text-size form-control group-name-text" disabled name="phonenumber">
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-4">
            <div class="form-group nameSet">
                <label for="country" class="lable-size">Country</label>
                <input type="text" [(ngModel)]="profileInfo.country" class="text-size form-control group-name-text"
                    disabled name="country">
            </div>
        </div>
        <div class="col-2"></div>
    </div>
    <div class="row" 
         *ngIf="currentTab=='profile' && profileInfo && !isEntityProfile">
        <div class="col-4">
            <div class="form-group nameSet">
                <label for="name" class="lable-size">Name </label>
                <input type="text" [(ngModel)]="profileInfo.first_name" class="text-size form-control group-name-text"
                    disabled name="name">
            </div>
            <div class="form-group nameSet">
                <label for="email" class="lable-size">Email</label>
                <input type="text" [(ngModel)]="profileInfo.email" class="text-size form-control group-name-text"
                    disabled name="email">
            </div>
            <div class="form-group nameSet">
                <label for="phonenumber" class="lable-size">Phone Number</label>
                <input type="text" [(ngModel)]="profileInfo.mobile"
                    class="text-size form-control group-name-text" disabled name="phonenumber">
            </div>
            
            <div class="form-group nameSet">
                <label for="dob" class="lable-size">DOB</label>
                <input type="text" [(ngModel)]="profileInfo.dob"
                    class="text-size form-control group-name-text" disabled name="dob">
            </div>
        </div>
        <div class="col-2"></div>
        <div class="col-4">
            <div class="form-group nameSet">
                <label for="country" class="lable-size">Country</label>
                <input type="text" [(ngModel)]="profileInfo.citizen[0].country" class="text-size form-control group-name-text"
                    disabled name="country">
            </div>
             <div class="form-group nameSet">
                <label for="phonenumber" class="lable-size">Phone Number</label>
                <input type="text" [(ngModel)]="profileInfo.mobile"
                    class="text-size form-control group-name-text" disabled name="phonenumber">
            </div> 
        </div>
        
        <div class="col-2"></div>
    </div> -->



    <!-- Profile Page -->   
    <div class="main-container">
      <div class="profile-container"> 

        <div class="profile-card"> 
        <h2 class="profile-title">
            <span (click)="back()"><i class="fa fa-angle-left goback" aria-hidden="true"></i></span>
            PROFILE
        </h2>

          <div class="profile-header">       
            <ng-container *ngIf="profileInfo.profile_pic; else noImage">
              <img [src]="profileInfo.profile_pic" class="avatar" />
            </ng-container>
            
            <ng-template #noImage>
              <div class="avatar-text">
               {{ (isEntityProfile ? profileInfo.fullname : profileInfo.first_name) | slice:0:1 }}
              </div>
            </ng-template>
      
            <div class="profile-info">
              <h2 class="name" *ngIf="isEntityProfile">{{ profileInfo.fullname }}</h2>
              <h2 class="name" *ngIf="!isEntityProfile"> {{ profileInfo.first_name }}  {{ profileInfo.last_name }}</h2>
              <p class="email">{{ profileInfo.email }}</p>

              <a (click)="toggleDetails()" class="toggle-link">
                View details   <i class="fa" [ngClass]="showDetails ? 'fa-angle-up' : 'fa-angle-down'" aria-hidden="true"></i>
              </a>
            </div>
          </div>
    
          <div class="details" *ngIf="showDetails">
            <div class="detail-row" *ngIf="isEntityProfile">
                <i class="fa-solid fa-user icon"></i>
                <div class="detail-label-group">
                    <strong>Contact Name</strong>
                    <p class="detail-value"> {{ profileInfo.contact_person || 'N/A' }}</p>
                </div>
            </div>
            <div class="detail-row" *ngIf="!isEntityProfile">
              <i class="fas fa-map-marker-alt icon"></i>
              <div class="detail-label-group">
                <strong>Home Address:</strong>
                <p class="detail-value">{{ primaryCitizen.home_address  || 'N/A' }}</p>
              </div>
            </div>
            <div class="detail-row">
              <i class="fas fa-globe icon"></i>
              <div class="detail-label-group">
                <strong>Country:</strong>
                <div class="country-display">
                  <img [src]="getFlagUrl(profileInfo?.country)" [alt]="profileInfo?.country + ' Flag'" class="flag-icon" *ngIf="getFlagUrl(profileInfo?.country)" />
                  <p class="detail-value">{{ isEntityProfile ? profileInfo.country : primaryCitizen?.country || 'N/A' }}</p>
                </div>
              </div>
            </div>
            <div class="detail-row">
              <i class="fa fa-phone icon"></i>
              <div class="detail-label-group">
                <strong>Mobile:</strong>
                <p class="detail-value">{{ getPhoneNumber() }}</p>
              </div>
            </div>
            <div class="detail-row" *ngIf="!isEntityProfile">
                <i class="fa fa-phone icon"></i>
                <div class="detail-label-group">
                    <strong>Work Phone:</strong>
                    <p class="detail-value">{{  primaryCitizen.work_phone  || 'N/A' }}</p>
                </div>
            </div>
            <div class="detail-row" *ngIf="!isEntityProfile">
                <i class="fa fa-phone icon"></i>
                <div class="detail-label-group">
                    <strong>Alt Phone:</strong>
                    <p class="detail-value">{{  primaryCitizen.alt_phone  || 'N/A' }}</p>
                </div>
            </div>
            <div class="detail-row" *ngIf="isEntityProfile">
                <i class="fa-brands fa-internet-explorer icon"></i>
                <div class="detail-label-group">
                    <strong>Website</strong>
                    <p class="detail-value">{{ profileInfo.website }}</p>
                </div>
            </div>
          </div>

        </div>
    
        <div class="shared-folder-card" *ngIf="isAccepted===true">
          <h2 class="section-title">SHARED FOLDER - DOCUMENTS
          <button class="add-new-btn" (click)="shareDocuments(profileInfo)">
            <span class="btn-text">Share Documents <i class="far fa-share-square icon-btn2"></i></span>
          </button>
         </h2>

          <div class="tabs">
            <div class="tab" [class.active]="activeTol === 'with'" (click)="loadFiles('with')">
              Shared With Me ({{ docsSharedwithus?.length || 0 }})
            </div>
          
            <div class="tab" [class.active]="activeTol === 'by'" (click)="loadFiles('by')">
              Shared By Me ({{ docsSharedbyus?.length || 0 }})
            </div>
          </div>

          <div class="search-section">
          <div class="search-container">
            <i class="material-icons">search</i>
            <input class="search-text" type="text" placeholder="Search for Document..." 
            [(ngModel)]="searchText">
          </div>
          </div>      
    
            <ng-container *ngIf="activeTol === 'with'">
            <div class="file-card" *ngFor="let file of docsSharedwithus | filter: searchText">
            <div class="file-info">
             <img src="assets/img/file.svg" alt="Upload">
              <div>
                <div class="file-names">{{ file.name }}
                    <div class="mconf" *ngIf="file?.matter_details.length!=0"><b class="conf">Confidential:</b> {{ getMatterNames(file) }}</div>
                </div>
                <div class="file-desc">{{ file.description }}</div>
              </div>
            </div>
                         
             <button *ngIf="activeTab !== 'corporate'" class="unbtn" (click)="viewDocShared(file)">
                <mat-icon class="unview">remove_red_eye</mat-icon>
            </button>
             <button *ngIf="activeTab === 'corporate'" class="unbtn" (click)="viewDoc(file)">
                <mat-icon class="unview">remove_red_eye</mat-icon>
            </button>

          </div>
          </ng-container>
          
          <ng-container *ngIf="activeTol === 'by'">
            <div class="file-card"  *ngFor="let file of docsSharedbyus | filter: searchText">
            <div class="file-info">
             <img src="assets/img/file.svg" alt="Upload">
              <div>
                <div class="file-names">{{ file.name }}
                   <div class="mconf" *ngIf="file?.matter_details.length!=0"><b class="conf">Confidential:</b> {{ getMatterNames(file) }}</div>
                </div>
                <div class="file-desc">{{ file.description }}</div>
              </div>
            </div>

            <button mat-icon-button [matMenuTriggerFor]="actionMenu">
              <i class="material-icons">more_vert</i>
            </button>
            <mat-menu #actionMenu="matMenu">
                <button mat-menu-item (click)="unShare(file,file.category)">
                    <mat-icon>undo</mat-icon>
                    <span>Unshare</span>
                </button>
            
                <button mat-menu-item (click)="viewGenDoc(file)">
                    <mat-icon>visibility</mat-icon>
                    <span>View</span>
                </button>
            </mat-menu>

          </div>
          </ng-container>

        </div>
    
      </div>
    </div>




    <!-- <div class="row" *ngIf="currentTab!='profile' && profileInfo">
        <div class="col-3">
            <div class="switch relationship-tabs">
                <span class="relSubTab individuals" (click)="currentTab='profile';isConformation=false;">
                    <a href="javascript: void(0)" [ngClass]="{'active' : currentTab=='profile'}"
                        class="optionone compone relation-sub-tabs">Profile</a>
                </span>
                <span class="relSubTab business" (click)="currentTab='documents';isConformation=false;">
                    <a href="javascript: void(0)"
                       [ngClass]="{'active' : currentTab=='documents'}"
                       class="optiontwo relation-sub-tabs compotwoo comptwo">Documents</a>
                </span>
            </div>
        </div>
        <div class="col-6"></div>
        <div class="col-3">
            <div class="switch relationship-tabs cswitch">
                <span class="relSubTab individuals"
                      (click)="currentInnerTab='sharedwithus';isConformation=false;">
                    <a href="javascript: void(0)"
                       [ngClass]="{'active' : currentInnerTab=='sharedwithus'}"
                       class="optionone compone relation-sub-tabs">Shared with us</a>
                </span>
                <span class="relSubTab business"
                    (click)="docssharedbyus();currentInnerTab='sharedbyus';isConformation=false;">
                    <a href="javascript: void(0)"
                       [ngClass]="{'active' : currentInnerTab=='sharedbyus'}"
                       class="optiontwo relation-sub-tabs compotwoo comptwo">Shared by us</a>
                </span>
            </div>
        </div>
    </div>  -->
    
    <!-- <div *ngIf="!isConformation">
        <div *ngIf="profileInfo && currentTab!='profile'">
            <div *ngIf="currentInnerTab=='sharedwithus'">
                <div class="row">
                    <div class="col-6"></div>
                    <div class="col-6">
                        <div class="form-group name-set float-right">
                            <div class="input-group group-custom-align court" id="search">
                                <input type="text"
                                       class="form-control textbox"
                                       placeholder="Search "
                                       [(ngModel)]="searchText"/>
                                <img src="assets/img/search.svg"
                                     class="calimg calitem input-group-append searchimg">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6" *ngIf="reldata.clientType == 'Entity'">
                        <h3 class="docName">Documents Shared with us - {{profileInfo.fullname}}</h3>
                    </div>
                    <div class="col-6" *ngIf="reldata.clientType == 'Consumer'">
                        <h3 class="docName" >Documents Shared with us - {{profileInfo.first_name}} {{profileInfo.last_name}}</h3>
                    </div>
                    <div class="col-6"></div>
                </div>
                <table class="table table-borderless tblgrid"
                       *ngIf="docsSharedwithus && docsSharedwithus.length>0" >
                    <thead>
                        <tr class="theader">
                            
                            <th>
                                <p class="thheadname">Document Name</p>
                                <img src="assets/img/SORT.PNG" class="sortico"
                                    (click)="sort('name',docsSharedwithus)">
                            </th>
                            <th>
                                <p class="thheadname">Shared On</p>
                                <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('created', docsSharedwithus)">
                            </th>
                            <th>
                                <p class="thheadname">Description</p>
                                <img src="assets/img/SORT.PNG" class="sortico"
                                    (click)="sort('description',docsSharedwithus)">
                            </th>
                            <th style="width:25%;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="rone veiw-items"  #docRow *ngFor="let doc of docsSharedwithus |filter:searchText" [class.actives]="doc.isHighlighted">
                            <td><strong>{{doc.name}}</strong><br>
                                <div *ngIf="doc?.matter_details.length!=0"><b class="conf">Confidential:</b> {{ getMatterNames(doc) }}</div>
                            </td>
                            <td>{{doc.sharedOn}}</td>
                            <td style="width:30%;">{{doc.description}}</td>
                            <td *ngIf="activeTab != 'corporate'">
                                <button type="button" *ngIf="!doc.added_encryption" class="btn btn-default btnsave savecls actionbtn"
                                    (click)="copyWithmeDoc(doc)">Copy</button>
                                <button type="button" class="btn btn-default btnsave savecls actionbtn"
                                        (click)="viewDocShared(doc)">View</button>
                            </td>
                            <td *ngIf="activeTab == 'corporate' ">
                                <button type="button" class="btn btn-default btnsave savecls actionbtn"
                                        (click)="viewDoc(doc)">View</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="currentInnerTab=='sharedbyus'">
                <div class="row">
                    <div class="col-6"></div>
                    <div class="col-6">
                        <div class="form-group name-set float-right">
                            <div class="input-group group-custom-align court" id="search">
                                <input type="text"
                                       class="form-control textbox"
                                       placeholder="Search"
                                       [(ngModel)]="searchText" />
                                <img src="assets/img/search.svg"
                                     class="calimg calitem input-group-append searchimg">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6" *ngIf="reldata.clientType == 'Entity'">
                        <h3 class="docName">Documents Shared by us - {{profileInfo.fullname}}</h3>
                    </div>
                    <div class="col-6" *ngIf="reldata.clientType == 'Consumer'">
                        <h3 class="docName">Documents Shared by us - {{profileInfo.first_name}} {{profileInfo.last_name}}</h3>
                    </div>
                    <div class="col-6"></div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="sharedblock">
                          <label for="court">Shared Documents</label>
                            <div class="tog"
                                 (click)="viewSharedDoc=!viewSharedDoc">
                            <span class="fa fa-plus "
                                  *ngIf="!viewSharedDoc"></span>
                            <span class="fa fa-minus "
                                  *ngIf="viewSharedDoc"></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id='no-shared-msg' *ngIf="viewSharedDoc && docsSharedbyus.length == 0">
                    <h5>No documents shared!</h5>
                </div>
                <table class="table table-borderless tblgrid"
                       *ngIf="viewSharedDoc && docsSharedbyus && docsSharedbyus.length>0">
                    <thead>
                        <tr class="theader">
                            <th>
                                <p class="thheadname">Document Name</p>
                                <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('name',docsSharedbyus)">
                            </th>
                            <th>
                                <p class="thheadname">Shared On</p>
                                <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('created', docsSharedbyus)">
                            </th>
                            <th>
                                <p class="thheadname">Description</p>
                                <img src="assets/img/SORT.PNG" class="sortico"
                                    (click)="sort('description',docsSharedbyus)">
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="rone veiw-items"
                            *ngFor="let doc of docsSharedbyus |filter:searchText"
                            [class.active]="doc.highlight">
                            <td><strong>{{doc.name}}</strong><br>
                                <div *ngIf="doc?.matter_details.length!=0"><b class="conf">Confidential:</b> {{ getMatterNames(doc) }}</div>

                            </td>
                            <td>{{doc.sharedOn}}</td>
                            <td style="width:30%;">{{doc.description}}</td>
                            <td style="width:25%;">
                                <button type="button" class="btn btn-default btnsave savecls actionbtn" 
                                        (click)="unShare(doc,doc.category)">Unshare</button>
                                <button type="button" class="btn btn-default btnsave savecls actionbtn"
                                        data-toggle="modal"
                                        data-target="#viewWithmeModal"
                                        (click)="viewGenDoc(doc)">View</button>
                                
                                        
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row" *ngIf="currentInnerTab!='sharedwithus'" style="margin-top:10px;">
                <div class="col-6">
                    <div class="sharedblock">
                      <label for="court">Share Documents</label>
                        <div class="tog" (click)="clientandfirmviewexpanded=!clientandfirmviewexpanded">
                        <span class="fa fa-plus"
                              *ngIf="!clientandfirmviewexpanded"></span>
                        <span class="fa fa-minus"
                              *ngIf="clientandfirmviewexpanded"></span>
                        </div>
                    </div>
                </div>
                <div class="col-6"></div>
            </div>
            <div *ngIf="currentInnerTab!='sharedwithus' && clientandfirmviewexpanded==true">
                <div class="row">
                    <div class="col-6"></div>
                    <div class="col-6">
                        <div class="form-group name-set float-right">
                            <div class="input-group group-custom-align court" id="search">
                                <input type="text" class="form-control textbox" placeholder="Search "
                                    [(ngModel)]="searchDocText" />
                                <img src="assets/img/search.svg" class="calimg calitem input-group-append searchimg">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">

                        <div class="switch relationship-tabs cswitch clf" *ngIf="product != 'corporate'">
                            <span class="relSubTab individuals"
                                (click)="viewClientDocuments=true;viewFirmDocuments=false;">
                                <a href="javascript: void(0)" [ngClass]="{'active' : viewClientDocuments==true}"
                                   class="optionone compone relation-sub-tabs">Client Documents</a>
                            </span>

                            <span class="relSubTab business"
                                (click)="viewFirmDocuments=true;viewClientDocuments=false;">
                                <a href="javascript: void(0)" [ngClass]="{'active' : viewFirmDocuments==true}"
                                    class="optiontwo relation-sub-tabs compotwoo comptwo">Firm Documents</a>
                            </span>
                        </div>

                        <div class="switch relationship-tabs cswitch" *ngIf="product == 'corporate'">
                            <span class="relSubTab business" (click)="!viewFirmDocuments;">
                            <a href="javascript: void(0)" [ngClass]="{'active' : viewFirmDocuments==true}"
                                class="optiontwo relation-sub-tabs compotwoo comptwo firms">External Documents</a>
                            </span>
                        </div>

                    </div>
                    <div class="col-6"></div>
                </div>
                <table class="table table-borderless tblgrid" *ngIf="viewClientDocuments && clientDocuments.length>0 && product != 'corporate'">
                    <thead>
                        <tr class="theader">
                            <th>
                                <p class="thheadname">Document Name</p>
                                <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('name',clientDocuments)">
                            </th>
                            <th>
                                <p class="thheadname">Created On</p>
                                <img src="assets/img/SORT.PNG" class="sortico"
                                    (click)="sort('created',clientDocuments)">
                            </th>
                            <th>
                                <p class="thheadname">Description</p>
                                <img src="assets/img/SORT.PNG" class="sortico"
                                    (click)="sort('description',clientDocuments)">
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="rone veiw-items" 
                            *ngFor="let doc of clientDocuments |filter:searchDocText"
                            [class.active]="doc.highlight || doc.isHighlighted">
                            <td><strong>{{doc.name}}</strong><br>
                                <div *ngIf="doc?.matter_details.length!=0"><b class="conf">Confidential:</b> {{doc?.matter_details[0].name}}</div>
                            </td>
                            <td>{{doc.created}}</td>
                            <td style="width:30%;">{{doc.description}}</td>
                            <td style="width:25%;">
                                <button type="button" class="btn btn-default btnsave savecls actionbtn"
                                    (click)="share(doc,'client')">Share</button>
                                <button type="button" class="btn btn-default btnsave savecls actionbtn" data-toggle="modal"
                                    data-target="#viewWithmeModal" (click)="viewGenDoc(doc)">View</button>
                              
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table class="table table-borderless tblgrid" *ngIf="viewFirmDocuments && firmDocuments.length>0 && product != 'corporate'">
                    <thead>
                        <tr class="theader">
                            <th>
                                <p class="thheadname">Document Name</p>
                                <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('name',firmDocuments)">
                            </th>

                            <th>
                                <p class="thheadname">Created On</p>
                                <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('created',firmDocuments)">
                            </th>
                            <th>
                                <p class="thheadname">Description</p>
                                <img src="assets/img/SORT.PNG" class="sortico"
                                    (click)="sort('description',firmDocuments)">
                            </th>

                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="rone veiw-items"
                            *ngFor="let doc of firmDocuments |filter:searchDocText"
                            [class.active]="doc.highlight || doc.isHighlighted">
                            <td>{{doc.name}}</td>
                            <td>{{doc.created}}</td>
                            <td style="width:30%;">{{doc.description}}</td>
                            <td style="width:25%;">
                                <button type="button" class="btn btn-default btnsave savecls actionbtn"
                                    (click)="share(doc,'firm')">Share</button>
                                <button type="button" class="btn btn-default btnsave savecls actionbtn" data-toggle="modal"
                                    data-target="#viewWithmeModal" (click)="viewGenDoc(doc)">View</button>
                                
                            </td>
                        </tr>
                    </tbody>
                </table>

<!-- Only for Corporate--
<table class="table table-borderless tblgrid" *ngIf="!viewFirmDocuments && firmDocuments.length>0 && product == 'corporate'">
    <thead>
        <tr class="theader">
            <th>
                <p class="thheadname">Document Name</p>
                <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('name',firmDocuments)">
            </th>

            <th>
                <p class="thheadname">Created On</p>
                <img src="assets/img/SORT.PNG" class="sortico" (click)="sort('created',firmDocuments)">
            </th>
            <th>
                <p class="thheadname">Description</p>
                <img src="assets/img/SORT.PNG" class="sortico"
                    (click)="sort('description',firmDocuments)">
            </th>

            <th></th>
        </tr>
    </thead>
    <tbody>
        <tr class="rone veiw-items"
            *ngFor="let doc of firmDocuments |filter:searchDocText"
            [class.active]="doc.highlight">
            <td><strong>{{doc.name}}</strong><br>
                <div *ngIf="doc?.matter_details.length!=0"><b class="conf">Confidential:</b> {{doc?.matter_details[0].name}}</div>
            </td>
            <td>{{doc.created}}</td>
            <td style="width:30%;">{{doc.description}}</td>
            <td style="width:25%;">
                <button type="button" class="btn btn-default btnsave savecls actionbtn"
                    (click)="share(doc,'firm')">Share</button>
                <button type="button" class="btn btn-default btnsave savecls actionbtn" data-toggle="modal"
                    data-target="#viewWithmeModal" (click)="viewGenDoc(doc)">View</button>
                
            </td>
        </tr>
    </tbody>
</table>
<!-- Only for Corporate--

            </div>
        </div>
    </div> -->

    <!-- <div class="btnbox" *ngIf="currentTab!='profile' && currentInnerTab!='sharedwithus' && !isConformation">
        <button type="reset" class="btn btn-default btncancel" (click)="cancel()">Cancel</button>
        <button type="submit" [disabled]="!(sharedandUnsharedData.add.length>0||sharedandUnsharedData.remove.length>0)"
            class="btn btn-default btnsave savecls" (click)="shareClick()">Share</button>

    </div> -->
    <!-- <div class="col-2"></div> -->
    <!-- <div *ngIf="isConformation">
        <div class="row main  stepitem ">
          <div class="col-xs-12 col-sm-12 col-md-6">
            <div class="row containerbox containerboxone containerboxformfile relshare gridfbox">
              <div class="col-sm-12">
                <div class="container">
                  
                    <div class="sharedblock sharedblue">
                      <label for="court">Shared Documents</label>
                      <div class="tog">
                        <span class="fa fa-plus" *ngIf="!viewSharedDoc" ></span>
                        <span class="fa fa-minus" *ngIf="viewSharedDoc" style="display: none;"></span>
                      </div>
                    </div>
                    <div *ngIf="openconfirmationunmodifiedDoc && unchangedDocs?.length>0"
                        class="sharedgird shared bluetxt">
                        <p *ngFor="let doc of unchangedDocs">
                            {{doc.name}}
                        </p>
                    </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-xs-12 col-sm-12 col-md-6">
            <div class="row containerbox containerboxformfile sharedboxitem">
              <div class="col-sm-12">
                <div class="container">
                  <div class="sharedblock sharedgreen ">
                    <label for="court"
                        (click)="openconfirmationAddedDoc=!openconfirmationAddedDoc">
                            Newly Shared Documents
                    </label>
                    <div class="tog">
                      <span class="fa fa-plus  sharedgreenminus " style=""></span>
                      <span class="fa fa-minus sharedgreenplus" style="display: none;"></span>
                    </div>
                  </div>
                  <div class="sharedgird shared greentxt together" class="col-6">
                    <div *ngIf="openconfirmationAddedDoc && sharedandUnsharedData?.add?.length>0">
                        <div class="nameandlist" *ngFor="let doc of sharedandUnsharedData.add">
                

                            <div class="immigrationtxt">{{doc.name}}
                                <p *ngIf="(product === 'lauditor' || product === 'corporate') && doc?.matter_details[0]?.name" class="matter-details">
                                  <strong class="docmatter">- </strong> {{doc?.matter_details[0]?.name}}</p>
                            </div>

                                <div class="pull-right matS" *ngIf="(activeTab !== 'individuals') && (product === 'content' && reldata.plan !== 'connect' || product === 'connect' && reldata.plan !== 'content')">
                                <mat-select multiple placeholder="Select Matters" (selectionChange)="updateMatters(doc, $event.value)">
                                    <mat-option *ngFor="let matters of matterList" [value]="matters">{{matters.matterTitle}}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                        
                        
                    </div>
                </div>
                 
                  <div class="sharedblock sharedred">
                    <label for="court ">Unshared Documents</label>
                    <div class="tog">
                      <span class="fa fa-minus sharedredminus " style=""></span>
                      <span class="fa fa-plus sharedredplus" style="display: none;"></span>
                    </div>
                  </div>
                  <div *ngIf="openconfirmationRemovedDoc && sharedandUnsharedData?.remove?.length>0"
                    class="sharedgird shared redtxt">
                        <div class="immigrationtxt" *ngFor="let doc of sharedandUnsharedData.remove">{{doc.name}}
                           <p *ngIf="(product === 'lauditor' || product === 'corporate') && doc?.matter_details[0]?.name" class="matter-details"> 
                            <strong class="docmatter">&nbsp;-&nbsp;</strong>{{doc?.matter_details[0]?.name}}</p>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row main stepitem">
        
          <div class="col-sm-12 gridtable gridtablecls gridmsg ">
            <div class="form-group">
              <label for="comment" class="msgoption">Message (Optional)</label>
              <textarea class="form-control" rows="5" id="comment" [(ngModel)]="message"
                        placeholder="Please review before sharing"></textarea>
            </div>
            <div class="btnbox btndocshare">
              <button type="reset" class="btn btn-default btncancel" (click)="onReset()">Cancel</button>
              <button type="submit" (click)="updateShareandUnshareDoc()"
                      class="btn btn-default btnsave btnshared">Share</button>
              
          </div>
         
        </div>
    </div>
    </div> -->



    <!-- Document Preview Modal -->
    <div *ngIf="isPreviewOpen" class="preview-modal">
        <div class="preview-content">
            <div class="preview-header">
                <h2>{{previewDocument?.name}}</h2>
                <button mat-icon-button (click)="closePreview()">
                    <i class="material-icons">close</i>
                </button>
            </div>
            <div class="preview-body">
                <!-- 🌀 Spinner overlay -->
                <div *ngIf="isLoading" class="spinner-overlay">
                    <mat-spinner diameter="40"></mat-spinner>
                </div>
    
                <ng-container *ngIf="previewDocument">
                    <img *ngIf="isImage(previewDocument.mimeType)" [src]="previewDocument.previewUrl"
                        [alt]="previewDocument.name" class="preview-image" (load)="onPreviewLoad()" />
                    <iframe width="98%" margin-top="20px" height="80%"
                        *ngIf="previewDocument.mimeType === 'application/pdf'" [src]="previewDocument.previewUrl"
                        frameborder="0" (load)="onPreviewLoad()"></iframe>
                </ng-container>
            </div>
        </div>
    </div>
    <!-- Document Preview Modal -->


    <!-- UnShare Documents Dialog -->
    <div *ngIf="isShareDialogOpen" class="custom-overlay">

        <div class="confirmation-dialog">
            <i class="fa fa-times close-button" (click)="onCancel()"></i>

            <!-- Icon -->
            <div class="icon-wrapper">
                <div class="icon-circle">
                    <mat-icon>share</mat-icon>
                </div>
            </div>

            <!-- Text Content -->
            <div class="dialog-text">
                <h2>Are you sure want to unshare
                <span class="file-names">
                    {{ selectedDoc?.name }}
                </span>?
                </h2>

                <!-- <p class="sub-text">
                            document with
                        </p>
                
                        <div class="firm-name">
                            {{ selectedFirmName }} ?
                        </div> -->
            </div>

            <!-- Buttons -->
            <div class="dialog-actions">
                <button class="btn-cancel" (click)="onCancel()">Cancel</button>
                <button class="btn-unshare" (click)="confirmUnshare()">Unshare</button>
            </div>

        </div>
    </div>
    <!-- UnShare Documents Dialog -->


<ngx-spinner  size="medium" type="ball-clip-rotate"></ngx-spinner>